
import { Watch, BaseTLTableComponent, AxiosResponse, Component, GroupService, GroupFilter, Vuex, Vue, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";
	import storeGlobal from '../../../Infrastructure/CorBase/StoreBase';

	Vue.use(Vuex);
	const store = new Vuex.Store({
		state: {
			groupListTableUse: true
		}
	})


	export default abstract class GroupListBase extends BaseTLTableComponent {
		groups: any[] = [];
		selectedGroupId: number = 0;
		isSuccessfully: boolean = false;

		groupService: GroupService = new GroupService();
		useTable = true;


		showAllertToDeleteClickBase(itemsSelected: any) {
			this.showAlertBeforeActionClickBase(itemsSelected, this.$t('group.messageQuestionMain').toString(), true);
		}


		selectRows(items: any) {
			super.selectRows(items);
		}


		callActionClick() {
			this.isBusy = true;

			this.deleteItemsList = this.getSelectedList();
			super.deleteList();				

			this.itemsSelected = null;
			(this.$refs.groupsTable as BaseTLTableBase).clearSelected();
		}

		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.groupService.deleteList(this.deleteItemsList);
		}

	
		//stromova priprava
		preparedChildren(items: any[]) {

			if (this.children.length == 0) {

				let listAll = items;
				let forChildren: any[] = [];
				let continueNode: any[] = [];

				let isExistChild = true;
				while (isExistChild) {
					isExistChild = false;
					continueNode.length = 0;
					forChildren.length = 0;

					for (var item of listAll) {
						if (item.children == undefined) {
							item.children = [];
						}
						let existuje = listAll.find(c => c.idGroup == item.id && c.id != c.idGroup);
						if (existuje == null && item.idGroup != null && item.id != item.idGroup) {
							isExistChild = true;
							forChildren.push(this.prepareItem(item));
						}
						else {
							continueNode.push(this.prepareItem(item)); //pokračuje k dalsimu zpracovani
						}
					}

					listAll.length = 0;
					for (var item of continueNode) {

						for (var child of forChildren) {
							if (child.idGroup == item.id) {
								item.children.push(this.prepareItem(child));
							}
						}
						listAll.push(this.prepareItem(item));
					}
				}
				this.children = listAll;
			}
		}

		prepareItem(item: any) {
			return { id: item.id, name: item.name, idGroup: item.idGroup, children: item.children, description: item.description };
		}

		prepareTableItem(item: any, nameParent: any) {
			return { id: item.id, name: item.name, idGroup: nameParent, children: item.children, description: item.description, isEditableRow: item.isEditableRow };
		}

		children: any[] = [];
	//	forTable: any[] = [];

		prepareData() {

			let treeData = {
				name: 'Groups',
				notEdit: true,
				root: true,
				children: this.children
			}
			return treeData;
		}

		changeChecked() {
			store.state.groupListTableUse = !this.useTable;
			this.useTable = !this.useTable;
			this.fetchData();
		}

		canCreateNew(): boolean {
			return this.canCreate && this.useTable;
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let groupFilter: GroupFilter = new GroupFilter(null, null, storeGlobal.state.idTenant , 'GROUP');
			return this.groupService.getAllByFilter(groupFilter);		
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		prepareItems(items: any[]) {
			this.tableData = [];
			for (var item of items) {
				let nameParent = '';
				let parentItem = (items.filter(c => c.id == item.idGroup)[0]);
				if (parentItem != undefined) {
					nameParent = parentItem.name;
				}
				this.tableData.push(this.prepareTableItem(item, nameParent));				
			}

			if (!this.useTable) {			
				  this.preparedChildren(items);
			}
		}


		setFields() {
			this.fields = [
				{ key: 'idGroupText', label: this.$t('group.fieldSuperior'), trans: 'group.fieldSuperior', sortable: true, class: 'text-left' },
				{ key: 'name', label: this.$t('group.fieldName'), trans: 'group.fieldName', sortable: true, class: 'text-left', design: 'detail' },
				{ key: 'description', label: this.$t('group.fieldDescription'), trans: 'group.fieldDescription', sortable: true, class: 'text-left' },
				{ key: 'actions', label: this.$t('group.fieldActions'), trans: 'group.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
			];
		}

		//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'name', label: this.$t('group.filterName'), trans: 'group.filterName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'description', label: this.$t('group.filterDescription'), trans: 'group.filterDescription', selected: false, value: null, type: 'text' },				];
			}
		}

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
			this.setfilters(null);
		}

	}

